export default __webpack_public_path__ + "static/media/chem420.a73ea56b.svg";